export const maxIdleTimeInMinutes = 25;
export const minutesToLogoutAfterWarningDialog = 5;
export const minutesToMilliseconds = 60 * 1000;
export const millisecondsToLogoutAfterWarningDialog = minutesToLogoutAfterWarningDialog * minutesToMilliseconds;
export const idleTimeToWarningDialogInMilliseconds = (maxIdleTimeInMinutes - minutesToLogoutAfterWarningDialog) * minutesToMilliseconds;
export const topLine = 'Session Timeout Approaching'
export const content = 'Your session will expire soon. Click CONTINUE SESSION to continue your session.'
export const buttonText = 'CONTINUE SESSION'